module.exports = __webpack_public_path__ + "assets/img/google.d68a5ce7.png";